import { errorToast } from '@components/toasts/Toasts';
import { useAbortEffect } from '@shared/hooks/useAbortEffect';
import { reportAppError } from '@shared/reportAppError';
import { useRestaurant } from '../../context/useRestaurant';
import { getListings } from './apiHelpers';

export const useListings = () => {
  const { id: restaurantId } = useRestaurant();

  const {
    data: listings = [],
    isPending: isLoading,
    rerun: refreshListings,
  } = useAbortEffect(
    {
      effect: (signal) => getListings(restaurantId, signal),
      onError: (e) => {
        errorToast({ message: 'Error loading listings' });
        reportAppError(e);
      },
    },
    [restaurantId],
  );

  return {
    listings,
    isLoading,
    refreshListings,
  };
};
